<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t("backmsglist") }}</h2>
		<el-divider></el-divider>

		<template>
			<export-excel :data="tableDataExcel" :fields="tableDataExcelFields" :name="$t('backmsglist') + '.xls'"
				class="el-button el-button--default">
				{{ $t("exportCustomerMsg") }}
			</export-excel>
			<!--<el-button @click="luckydraw" v-if="qyid == 598 || qyid == 605">{{ $t('draw') }}</el-button>-->
		</template>
		<br />
		<br />
		<el-collapse>
			<el-collapse-item :title="$t('searchByConditions')" name="1">
				<el-form ref="storeform" :model="storeform">
					<el-form-item :label="$t('selectStore')">
						<template>
							<div class="" style="display: flex">
								<el-select v-model="storeform.storeid" placeholder="" @change="changeStoreid">
									<el-option :label="$t('all')" value=""></el-option>
									<el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
										:value="item.storeid"></el-option>
								</el-select>
							</div>
						</template>
					</el-form-item>
				</el-form>
				<div>
					<el-form ref="timeform" :model="typeform">
						<el-form-item :label="$t('time')">
							<template>
								<div class="" style="display: flex">
									<el-date-picker v-model="starttime" type="datetime"
										:placeholder="$t('selectDatetime')">
									</el-date-picker>{{ $t('to') }}
									<el-date-picker v-model="endtime" type="datetime"
										:placeholder="$t('selectDatetime')">
									</el-date-picker>
								</div>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<el-form ref="typeform" :model="typeform">
						<el-form-item :label="$t('type')">
							<template>
								<div class="" style="display: flex">
									<el-select v-model="typeform.type" placeholder="">
										<el-option :label="$t('all')" value=""></el-option>
										<el-option label="button_reply" value="button_reply"></el-option>
										<el-option label="text" value="text"></el-option>
									</el-select>
								</div>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<el-form ref="messageform" :model="messageform">
						<el-form-item :label="$t('message')">
							<template>
								<div class="" style="display: flex">
									<el-input v-model="messageform.message"></el-input>
								</div>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<el-form ref="sendernameform" :model="phoneform">
						<el-form-item :label="$t('sender')">
							<template>
								<div class="" style="display: flex">
									<el-input v-model="sendernameform.sendername"></el-input>
								</div>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<el-form ref="phoneform" :model="phoneform">
						<el-form-item :label="$t('phoneNumber')">
							<template>
								<div class="" style="display: flex">
									<el-input v-model="phoneform.phone"></el-input>
								</div>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<el-form ref="groupbyform" :model="groupbyform">
						<el-form-item :label="$t('group')">
							<template>
								<div class="" style="display: flex">
									<el-select v-model="groupbyform.groupby" placeholder="">
										<el-option label="False" value="false"></el-option>
										<el-option label="True" value="true"></el-option>
									</el-select>
								</div>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="filter()">{{ $t('search') }}</el-button>
			</el-collapse-item>
		</el-collapse>
		<br />
		<!--
		<template v-if="qyid==598 || qyid==605 || qyid==133">
			<export-excel
			:data="tableData"
			:fields = "tableDataExcelFields"
			name="顧客信息.xls"
			class="el-button el-button--default">
				匯出顧客信息
			</export-excel>
		</template>-->


		<!-- <el-button @click="dialogVisible=true">{{$t('addTemplate')}}</el-button> -->
		<!--     <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs> -->
		<el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" stripe
			@sort-change="sortChange" style="width: 100%">
			<el-table-column prop="addtime" :label="$t('date')" sortable="custom" width="">
				<template slot-scope="scope">
					<div>{{ scope.row.addtime | formatDate }} </div>
				</template>
			</el-table-column>
			<el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width=""></el-table-column>
			<el-table-column prop="body" :label="$t('message')" sortable="custom" width="">
				<template slot-scope="scope">
					<div>{{ decodeString(scope.row.body) }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="type" :label="$t('type')" sortable="custom" width=""></el-table-column>
			<el-table-column prop="phone" :label="$t('phoneNumber')" sortable="custom" width=""></el-table-column>
			<el-table-column prop="sendername" :label="$t('sender')" sortable="custom" width=""></el-table-column>
			<el-table-column prop="operation" :label="$t('adminset')" align="center" width="">
				<template slot-scope="scope">
					<div class="operationVid">
						<el-button @click="huifu(scope.row)">{{ $t('reply') }}</el-button>
					</div>
				</template>
			</el-table-column>

		</el-table>
		<div class="pagination flex-center">
			<span class="el-pagination__total">{{ $t("total") }} {{ tableData.length }} {{ $t("items") }}</span>
			<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
				:page-size="pageSize" layout="prev,pager,next" :total="tableData.length"></el-pagination>
		</div>

		<!-- add -->
		<el-dialog :title="$t('addTemplate')" :visible.sync="dialogVisible" width="556px" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">

					<el-form-item :label="$t('templateType')">
						<el-select v-model="form.type" placeholder="">
							<el-option :label="$t('textTemplate')" value="1"></el-option>
							<el-option :label="$t('picturesAndText')" value="2"></el-option>
							<el-option :label="$t('ComprehensiveTemplate')" value="3"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="$t('templateName')">
						<el-input v-model="form.title"></el-input>
					</el-form-item>

					<el-form-item :label="$t('TemplateText')">
						<el-input v-model="form.detail" type="textarea" :rows="2"></el-input>
					</el-form-item>

					<el-form-item v-if="form.type == 2">
						<img width="100%" :src="form.pic" alt="">
						<el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="sure">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>


		<!-- 回覆单个客户 -->
		<el-dialog :title="`${$t('reply')} ${hfdata.sendername}`" :visible.sync="dialogReplyVisible" width="556px"
			:before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="formReply">

					<!--           <el-form-item :label="$t('templateType')">
                        <el-select v-model="form.type" placeholder="">
                            <el-option :label="$t('textTemplate')" value="1"></el-option>
                            <el-option :label="$t('picturesAndText')" value="2"></el-option>
                            <el-option :label="$t('ComprehensiveTemplate')" value="3"></el-option>
                        </el-select>
                    </el-form-item> -->

					<!-- Chat Session -->
                     <!--
					<div class="chat-session" ref="chatSession">
						<div v-for="(record, index) in groupedRecords" :key="record.id || `date-${index}`">
							<div v-if="record.isDate" class="date-separator">{{ record.date }}</div>

							<div v-else class="chat-message">
								<div class="chat-time">{{ new Date(record.addtime * 1000).toLocaleTimeString()
									}}</div>
								<div class="chat-body">{{ record.body }}</div>
							</div>
						</div>
					</div>-->

					<!-- <span>whatsapp:{{hfdata.whatsapp}}</span> -->
					<el-form-item :label="$t('replyText')">
						<el-input v-model="formReply.msg" type="textarea" :rows="2"></el-input>
					</el-form-item>

					<!-- <el-form-item :label="$t('replyImage')">
						<el-input v-model="formReply.image" :rows="2"></el-input>
					</el-form-item> -->


				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogReplyVisible = false"> {{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="replyto">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>
		<!-- 回覆单个客户结束 -->



		<el-dialog :title="$t('draw')" :visible.sync="dialogLuckydrawVisible" width="556px" :before-close="handleClose">
			<span>{{ $t('winner') }}</span><br>
			<h2 class="page-title">{{ luckydrawResult.name }} {{ luckydrawResult.phone }}</h2>
		</el-dialog>

	</div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import { tongyong, sjk, getStore, addTemplate, funk, getReceiveHistory, getReceiveHistory_luckydraw } from '@/api'
export default {
	data() {
		return {
			sjk: 'messenger_receivehistory',
			//sjk:'messenger_backlist',
			currentPage: 1,  // 当前页码
			pageSize: 10,  // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			dialogReplyVisible: false,
			dialogLuckydrawVisible: false,
			tab: [
				{ label: this.$t('underApproval'), id: '0' },
				{ label: this.$t('passed'), id: '1' }
			],
			tableData: [],
			tableDataExcel: [],
			tableDataExcelFields: {
				'add time': 'addtime',
				'store id': 'storeid',
				'name': 'sendername',
				'mobile': 'phone',
				'type': 'type',
				'message': 'body',
			},
			storelist: [],
			sjkData: [],
			status: 0,
			form: {
				type: '1',
				title: '',
				text: '',
				qyid: '',
				status: '',
				pic: ''
			},
			storeform: {
				storeid: ''
			},
			timeform: {

			},
			typeform: {
				type: ''
			},
			messageform: {
				message: ''
			},
			sendernameform: {
				sendername: ''
			},
			phoneform: {
				phone: ''
			},
			groupbyform: {
				groupby: false
			},
			hfdata: [],
			hfrecord: [],
			formReply: {
				templateid: '',
				msg: '',

			},
			qyid: '',
			starttime: '',
			endtime: '',
			luckydrawResult: {
				name: '',
				phone: ''
			}
		}
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},
	created(option) {
		if (this.$route.params.sjk) {
			this.sjk = this.$route.params.sjk
		}

		console.log('sjk', this.sjk);
		if (this.sjk) {
			this.getsjk()
			this.gettemplist('')
		}
		var user = JSON.parse(window.localStorage.getItem('userinfo'))
		this.qyid = user.id
		this.getstorelist();
	},
	computed: {
		groupedRecords() {
			let grouped = [];
			let lastDate = null;

			this.hfrecord.forEach((record) => {
				const recordDate = new Date(record.addtime * 1000).toLocaleDateString();

				// Check if the date is different from the last record's date
				if (recordDate !== lastDate) {
					// Add a date separator to the grouped array
					grouped.push({ isDate: true, date: recordDate });
					lastDate = recordDate;
				}

				// Decode Unicode in the chat record body
				let decodedBody = this.decodeString(record.body);

				// Add the chat record with the decoded body
				grouped.push({
					...record,
					body: decodedBody
				});
			});

			return grouped;
		},
	},
	methods: {
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist(this.storeform.storeid)
		},
		handleClose() {
			this.dialogVisible = false
			this.dialogReplyVisible = false
			this.dialogLuckydrawVisible = false
		},
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
		getstorelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				qyid: user.id,
			};
			getStore(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.storelist = res.data
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		changeStoreid() {
			console.log('storeid:' + this.storeform.storeid)
			this.gettemplist(this.storeform.storeid)
		},
		filter() {
			console.log('filter')
			console.log('this.storeform.storeid: ' + this.storeform.storeid)
			//let start_date_time = new Date(this.starttime).getDate() + '-' + (new Date(this.starttime).getMonth()+ 1) + '-' + new Date(this.starttime).getFullYear() + " " + new Date(this.starttime).getHours() + ":" + new Date(this.starttime).getMinutes() + ":" + new Date(this.starttime).getSeconds();
			//let end_date_time = new Date(this.endtime).getDate() + '-' + (new Date(this.endtime).getMonth()+ 1) + '-' + new Date(this.endtime).getFullYear() + " " + new Date(this.endtime).getHours() + ":" + new Date(this.endtime).getMinutes() + ":" + new Date(this.endtime).getSeconds();
			//console.log('starttime: ' + start_date_time)
			//console.log('endtime: ' + end_date_time)
			//console.log('typeform.type: ' + this.typeform.type)
			//console.log('messageform.message: ' + this.messageform.message)
			this.gettemplist(this.storeform.storeid)

		},
		// 新增範本点击确定
		sure() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			this.form.qyid = user.id
			this.form.status = 0
			addTemplate(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist(this.storeform.storeid)
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//删除某个
		delitem(id) {
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

				console.log('del..');
				let fdata = {
					sjk: this.sjk,
					action: 'del',
					id: id
				}
				tongyong(fdata).then(res => {
					if (res.code == 1) {
						console.log(res);
						this.gettemplist(this.storeform.storeid)
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			}).catch(_ => {



			})


		},
		// 我的模板列表
		gettemplist(storeid) {

			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let start_date_time = '';
			let end_date_time = '';
			if (this.starttime) {
				start_date_time = new Date(this.starttime).getFullYear() + '-' + (new Date(this.starttime).getMonth() + 1) + '-' + new Date(this.starttime).getDate() + " " + new Date(this.starttime).getHours() + ":" + new Date(this.starttime).getMinutes() + ":" + new Date(this.starttime).getSeconds();
			}
			if (this.endtime) {
				end_date_time = new Date(this.endtime).getFullYear() + '-' + (new Date(this.endtime).getMonth() + 1) + '-' + new Date(this.endtime).getDate() + " " + new Date(this.endtime).getHours() + ":" + new Date(this.endtime).getMinutes() + ":" + new Date(this.endtime).getSeconds();
			}

			let fdata = {
				sjk: this.sjk,
				action: 'list',
				// status:this.status,
				// moresearch:'status,',
				qyid: user.id,
				storeid: storeid,
				starttime: start_date_time,
				endtime: end_date_time,
				type: this.typeform.type,
				message: this.messageform.message,
				sendername: this.sendernameform.sendername,
				phone: this.phoneform.phone,
				groupby: this.groupbyform.groupby
			}
			console.log('go taocan', fdata);
			getReceiveHistory(fdata).then(res => {
				if (res.code == 1) {
					this.tableData = res.data
					console.log('tabeData', this.tableData);
					this.tableDataExcel = res.dataExcel
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		// 读取数据库结构
		getsjk() {
			console.log('go sjk');

			let fdata = {
				sjk: this.sjk,

			}
			sjk(fdata).then(res => {
				if (res.code == 1) {
					console.log('sjk', res);
					this.sjkData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		huifu(data) {
			this.dialogReplyVisible = true;
			this.formReply.msg = "";
			this.formReply.image = "";
			this.hfdata = data;
			console.log('hfdata', this.hfdata);
			this.hfrecord = this.tableData
				.filter(item => item.phone === this.hfdata.phone)
				.sort((a, b) => a.addtime - b.addtime);
			console.log('hfrecord', this.hfrecord);
		},
		luckydraw() {
			console.log('luckydraw');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let start_date_time = '';
			let end_date_time = '';
			if (this.starttime) {
				start_date_time = new Date(this.starttime).getFullYear() + '-' + (new Date(this.starttime).getMonth() + 1) + '-' + new Date(this.starttime).getDate() + " " + new Date(this.starttime).getHours() + ":" + new Date(this.starttime).getMinutes() + ":" + new Date(this.starttime).getSeconds();
			}
			if (this.endtime) {
				end_date_time = new Date(this.endtime).getFullYear() + '-' + (new Date(this.endtime).getMonth() + 1) + '-' + new Date(this.endtime).getDate() + " " + new Date(this.endtime).getHours() + ":" + new Date(this.endtime).getMinutes() + ":" + new Date(this.endtime).getSeconds();
			}

			let fdata = {
				//sjk: this.sjk,
				action: 'list',
				// status:this.status,
				// moresearch:'status,',
				qyid: user.id,
				//storeid: storeid,
				starttime: start_date_time,
				endtime: end_date_time,
				//type: this.typeform.type,
				//message: this.messageform.message,
				//phone: this.phoneform.phone,
				//groupby: this.groupbyform.groupby
			}
			console.log('go taocan', fdata);
			getReceiveHistory_luckydraw(fdata).then(res => {
				if (res.code == 1) {
					console.log('ressssssssssss');
					console.log(res);
					this.tableData = res.data
					this.tableDataExcel = res.dataExcel
					this.luckydrawResult.name = res.luckydrawdata.sendername
					this.luckydrawResult.phone = res.luckydrawdata.phone
					this.dialogLuckydrawVisible = true
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})



		},
		decodeString(str) {
			if (!str) {
				return str || '';
			}

			return str
				.replace(/\\u[\dA-F]{4}/gi, function (match) {
					return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
				})
				.replace(/\\n/g, '\n');
		},
		encodeString(str) {
			str = str.replace(/\n/g, '\\n');

			return str.split('').map(function (char) {
				const code = char.charCodeAt(0);
				if (code > 127) {
					return '\\u' + code.toString(16).padStart(4, '0');
				}
				return char;
			}).join('');
		},
		replyto() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			console.log('this.hfdataaaaaaaaaaaaaaaaaaaaaaaaa')
			console.log(this.hfdata)
			this.qyid = user.id
			let fdata = {
				do: 'sendwhatsapp',
				qyid: this.qyid,
				pageid: this.pageid,
				storeid: this.hfdata.storeid,
				msg: this.encodeString(this.formReply.msg),
				image: this.formReply.image,
				Phone: this.hfdata.phone,
				templateid: this.formReply.templateid

			}
			console.log("fdata");
			console.log(fdata);
			this.$confirm(this.$t('sendConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				funk(fdata).then(res => {
					if (res.code > 0) {
						console.log(res);
						this.gettemplist(this.storeform.storeid)
						this.$message({
							type: 'success',
							message: 'ok'
						})
						this.dialogReplyVisible = false;
					} else {
						this.$message({
							type: 'error',
							message: 'error'
						})
					}
				})
			}).catch(_ => {



			})
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		},
		scrollToBottom() {
			const chatSession = this.$refs.chatSession;
			chatSession.scrollTop = chatSession.scrollHeight;
		},
	},
	watch: {
		hfrecord() {
			this.$nextTick(() => {
				this.scrollToBottom();
			});
		},
		dialogReplyVisible(val) {
			if (val) {
				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

.chat-session {
	max-height: 300px;
	overflow-y: scroll;
	border: 1px solid #ebeef5;
	padding: 10px;
	margin-bottom: 20px;
	display: flex;
	flex-direction: column;
}

.chat-message {
	display: inline-block;
	margin-bottom: 15px;
	padding: 10px;
	border-radius: 10px;
	background-color: #549deb;
	color: white;
	width: fit-content;
	line-height: 1.5;
	max-width: 60%;
}

.chat-time {
	font-size: 12px;
	margin-right: 5px;
}

.chat-body {
	word-wrap: break-word;
	white-space: pre-wrap;
}

.date-separator {
	text-align: center;
	margin-top: 20px;
	margin-bottom: 5px;
	color: #666;
}

::v-deep .el-select {
	width: 100%;

}
</style>